import React from 'react';

import { Box } from '@mui/material';

import ListPage from '../../../sharedModules/listPage/ListPage';

const AppModulesListPage: React.FC = () => {
  const appModuleColumns = [
    {
      name: 'Module Name',
      selector: 'name',
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: 'Admin Users',
      selector: (row: any) => {
        const adminUsers = row.users_with_permissions?.filter((user: any) => user.permission_tier === 3) || [];
        return adminUsers.length;
      },
      sortable: true,
      grow: 1,
      cell: (row: any) => {
        const adminUsers = row.users_with_permissions?.filter((user: any) => user.permission_tier === 3) || [];
        return <Box sx={{ textAlign: 'center' }}>{adminUsers.length}</Box>;
      },
    },
    {
      name: 'Non-Admin Users',
      selector: (row: any) => {
        const nonAdminUsers =
          row.users_with_permissions?.filter((user: any) => user.permission_tier === 1 || user.permission_tier === 2) ||
          [];
        return nonAdminUsers.length;
      },
      sortable: true,
      grow: 1,
      cell: (row: any) => {
        const nonAdminUsers =
          row.users_with_permissions?.filter((user: any) => user.permission_tier === 1 || user.permission_tier === 2) ||
          [];
        return <Box sx={{ textAlign: 'center' }}>{nonAdminUsers.length}</Box>;
      },
    },
  ];

  return (
    <ListPage
      clickableRows
      columns={appModuleColumns}
      controller="admin/app_modules"
      queryPlaceholder="Filter by module name..."
      title="App Modules"
    />
  );
};

export default AppModulesListPage;
